import {
    forwardRef,
    InputHTMLAttributes,
    useEffect,
    useImperativeHandle,
    useRef,
} from "react";

export default forwardRef(function TextInput(
    {
        type = "text",
        className = "",
        isFocused = false,
        disabled = false,
        ...props
    }: InputHTMLAttributes<HTMLInputElement> & {
        isFocused?: boolean;
    },
    ref,
) {
    const localRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(ref, () => ({
        focus: () => localRef.current?.focus(),
    }));

    useEffect(() => {
        if (isFocused) {
            localRef.current?.focus();
        }
    }, [isFocused]);

    const baseClass =
        "rounded-md border-gray-300 shadow-sm focus:border-neutral4 focus:ring-neutral4 ring-neutral4 ";

    const disabledClass = "opacity-50 cursor-not-allowed ";

    return (
        <input
            {...props}
            type={type}
            disabled={disabled}
            className={baseClass + (disabled ? disabledClass : "") + className}
            ref={localRef}
        />
    );
});
